"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGlobalStyles = void 0;

var _variables = require("../variables");

var _reactJss = require("react-jss");

var useGlobalStyles = (0, _reactJss.createUseStyles)({
  // export const globalStyles = {
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      listStyle: "none",
      textDecoration: "none",
      outline: "none",
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box"
    },
    "::-webkit-scrollbar": {
      width: "12px"
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: _variables.colors.hare
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: _variables.colors.wolf,
      borderRadius: "20px",
      border: "2px solid ".concat(_variables.colors.hare)
    },
    body: {
      scrollbarWidth: "thin",
      scrollbarColor: "".concat(_variables.colors.wolf, " ").concat(_variables.colors.hare)
    },
    '.MuiTypography-body2': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiPickersClockNumber-clockNumber': {
      fontFamily: 'IranSansX !important'
    },
    // '.MuiIconButton-root': {
    //     position: "absolute !important",
    //     left: "-16% !important"
    // },
    '.MuiTypography-root': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiPickersCalendarHeader-dayLabel': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiTypography-alignCenter': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiTypography-alignLeft': {
      fontFamily: 'IranSansX !important',
      fontSize: "2rem !important"
    },
    '.MuiTypography-subtitle1': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiButton-label': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiPickersYear-yearSelected': {
      fontFamily: 'IranSansX !important'
    },
    '.MuiPickersToolbar-toolbar': {
      backgroundColor: "".concat(_variables.colors.father, " !important")
    },
    '.MuiPickersDay-daySelected:hover': {
      backgroundColor: "".concat(_variables.colors.mother, " !important")
    },
    '.MuiPickersDay-daySelected': {
      backgroundColor: "".concat(_variables.colors.mother, " !important")
    },
    '.MuiDialog-paperScrollPaper': {
      borderRadius: "10px !important"
    }
  }
});
exports.useGlobalStyles = useGlobalStyles;